<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div ref="search_form"></div>

    <el-tabs v-model="activeTab" type="card">
      <el-tab-pane :label="$t('매장 트리')" name="tree">
        <!-- 버튼 -->
        <div class="buttons" ref="buttons">
          <el-button v-if="checkAuthActionAccess('CustSearch')" :size="size" @click="search" icon="el-icon-search">{{
            $t('검색')
          }}</el-button>
          <el-button
            v-if="checkAuthActionAccess('CustAdd')"
            :size="size"
            @click="addCust"
            icon="el-icon-circle-plus-outline"
            >{{ $t('사업장 등록') }}</el-button
          >
          <el-button
            v-if="checkAuthActionAccess('StoreAddForMng')"
            :size="size"
            @click="addStore"
            icon="el-icon-circle-plus-outline"
            >{{ $t('매장 등록') }}</el-button
          >
          <el-button
            v-if="checkAuthActionAccess('CustDel')"
            :size="size"
            @click="del"
            icon="el-icon-remove-outline"
            :disabled="btn.delDisabled"
            >{{ $t('삭제') }}</el-button
          >
          <!-- 내부 운영자용 환불 실패 목록(매장 횡단) — 자동 취소 설정을 여기서 다루므로 그 결과도 여기서 연다 -->
          <el-button
            v-if="canOpenRefundPending"
            :size="size"
            icon="el-icon-warning-outline"
            data-testid="refund-pending-link"
            @click="openRefundPending"
            >{{ $t(refundText.pendingListTitle) }}</el-button
          >
        </div>

        <!-- 트리 -->
        <el-row :gutter="10">
          <el-col :md="6">
            <el-tree
              :data="treeData"
              node-key="label"
              :props="defaultProps"
              :style="{ height: tableHeight - 12 + 'px' }"
              :expand-on-click-node="false"
              @node-click="handleNodeClick"
              :default-expanded-keys="[]"
              ref="tree"
              :default-expand-all="true"
              :show-checkbox="true"
              :check-strictly="true"
              @check-change="treeCheckChange"
              style="overflow: auto; border: 1px solid #ebeef5; border-radius: 5px; padding: 5px"></el-tree>
          </el-col>
          <el-col :md="18">
            <!-- 사업장 입력 팝업 -->
            <div v-show="inputFormIsCust">
              <el-card shadow="never" :style="{ height: inputHeight + 'px' }" class="input-menu">
                <div slot="header">
                  <span>{{ inputFormCust.title }}</span>

                  <div style="float: right; margin-top: -5px">
                    <el-button icon="el-icon-check" size="mini" @click="save" :disabled="btn.saveDisabled">{{
                      $t('저장')
                    }}</el-button>
                  </div>
                </div>
                <div>
                  <el-form
                    :model="inputFormCust"
                    :label-width="$device.mobile ? `` : `180px`"
                    :label-position="$device.mobile ? `top` : ``"
                    label-suffix=":"
                    :size="size"
                    :disabled="fromDisabled"
                    @submit.native.prevent>
                    <el-row>
                      <el-col :md="12">
                        <el-form-item :label="$t('소속 사업장')">
                          <el-select
                            v-model="inputFormCust.topCust.custCd"
                            filterable
                            remote
                            default-first-option
                            style="width: 100%"
                            :placeholder="$t('사업장명을 입력 하여 검색')"
                            :remote-method="custSearch">
                            <el-option
                              v-for="item in cust"
                              :key="item.custCd"
                              :label="item.custCd == null ? '최상위 사업장' : item.custId + ' ' + item.custNm"
                              :value="item.custCd"></el-option>
                          </el-select>
                          <!--										<span class="show_cd">{{ inputFormCust.topCust.custNm }}</span>-->
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :md="12">
                        <el-form-item :label="$t('사업장명')" :error="formErrorCust.custNm" required>
                          <el-input v-model="inputFormCust.custNm" maxlength="50" clearable show-word-limit></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :md="12">
                        <el-form-item :label="$t('사업자 등록 번호')" :error="formErrorCust.busiNum">
                          <el-input
                            v-keep-number-caret
                            :value="util.bizNoFieldText(inputFormCust.busiNum)"
                            maxlength="20"
                            clearable
                            show-word-limit
                            @input="inputFormCust.busiNum = util.bizNoInputValue($event)"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :md="12">
                        <el-form-item :label="$t('대표자명')" :error="formErrorCust.ceoNm" required>
                          <el-input v-model="inputFormCust.ceoNm" maxlength="20" clearable show-word-limit></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :md="12">
                        <el-form-item :label="$t('사용 가능 여부')" required>
                          <combo
                            :data="mainVue.code.useYn"
                            :model="inputFormCust.useYn"
                            @change="inputFormCust.useYn = $event"></combo>
                        </el-form-item>
                      </el-col>
                      <ceo-verification-line :block="inputFormCust.ceoVerification"></ceo-verification-line>
                      <el-col :md="12">
                        <el-form-item :label="$t('전화번호')" :error="formErrorCust.tel" required>
                          <el-input
                            v-keep-number-caret
                            :value="util.telFieldText(inputFormCust.tel)"
                            maxlength="20"
                            clearable
                            show-word-limit
                            @input="inputFormCust.tel = util.telDigits($event)"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :md="12">
                        <el-form-item :label="$t('팩스번호')" :error="formErrorCust.fax">
                          <el-input
                            v-keep-number-caret
                            :value="util.telFieldText(inputFormCust.fax)"
                            maxlength="20"
                            clearable
                            show-word-limit
                            @input="inputFormCust.fax = util.telDigits($event)"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :md="12">
                        <el-form-item :label="$t('이메일')" :error="formErrorCust.email">
                          <el-input v-model="inputFormCust.email" maxlength="20" clearable show-word-limit></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :md="12">
                        <el-form-item :label="$t('가입일')" :error="formErrorCust.startDt" required>
                          <el-date-picker
                            v-model="inputFormCust.startDt"
                            type="date"
                            :placeholder="$t('가입일')"
                            value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :md="12">
                        <el-form-item :label="$t('탈퇴일')" :error="formErrorCust.endDt">
                          <el-date-picker
                            v-model="inputFormCust.endDt"
                            type="date"
                            :placeholder="$t('탈퇴일')"
                            value-format="yyyy-MM-dd"></el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :md="12">
                        <el-form-item :label="$t('정산은행')" :error="formErrorCust['bankTp.cd']">
                          <code-combo
                            :data="bankTp"
                            :model="inputFormCust.bankTp"
                            @change="inputFormCust.bankTp = $event"></code-combo>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :md="12">
                        <el-form-item :label="$t('정산계좌번호')" :error="formErrorCust.accountNumber">
                          <el-input
                            v-model="inputFormCust.accountNumber"
                            maxlength="20"
                            clearable
                            show-word-limit
                            @keyup.native="inputFormCust.accountNumber = util.inputBusiNumNew($event)"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :md="12">
                        <el-form-item :label="$t('예금주명')" :error="formErrorCust.accountName">
                          <el-input
                            v-model="inputFormCust.accountName"
                            maxlength="20"
                            clearable
                            show-word-limit></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :md="12">
                        <el-form-item :label="$t('우편 번호')" :error="formErrorCust.zipCd" required>
                          <el-input
                            v-model="inputFormCust.zipCd"
                            maxlength="10"
                            show-word-limit
                            style="width: 200px"
                            readonly></el-input>
                          <el-button @click="selectCustAddress()">{{ $t('주소 조회') }}</el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :md="12">
                        <el-form-item :label="$t('주소')" :error="formErrorCust.addr" required>
                          <el-input v-model="inputFormCust.addr" maxlength="250" show-word-limit readonly></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :md="12">
                        <el-form-item :label="$t('상세 주소')" :error="formErrorCust.addrDtl" required>
                          <el-input
                            ref="addr_dtl"
                            v-model="inputFormCust.addrDtl"
                            maxlength="50"
                            clearable
                            show-word-limit></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :md="24">
                        <el-form-item :label="$t('설명')" :error="formErrorCust.custDesc">
                          <el-input
                            v-model="inputFormCust.custDesc"
                            type="textarea"
                            maxlength="250"
                            show-word-limit></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :md="8">
                        <el-form-item :label="$t('첨부 파일')">
                          <el-upload
                            action=""
                            class="avatar-uploader"
                            accept="image/*"
                            :auto-upload="false"
                            :file-list="inputFormCust.files"
                            :on-change="custFileAdd"
                            :on-remove="custFileRemove"
                            multiple
                            list-type="picture">
                            <el-button slot="trigger" size="small" type="primary">{{ $t('파일 추가') }}</el-button>
                          </el-upload>
                        </el-form-item>
                      </el-col>
                      <el-col :md="8">
                        <div style="margin-top: 30px">&nbsp;</div>
                        <div
                          v-for="(item, index) in inputFormCust.files"
                          :key="index"
                          class="file_name"
                          style="margin-top: 10px; height: 92px"
                          v-if="'del' != inputFormCust.files[index].status">
                          <el-input
                            v-model="inputFormCust.files[index].name"
                            maxlength="50"
                            show-word-limit
                            :size="size"
                            type="textarea"
                            resize="none"
                            rows="4"
                            @change="fileNameChange(inputFormCust.files[index])"></el-input>
                        </div>
                      </el-col>
                    </el-row>
                  </el-form>
                  <!--
                    주문 미수락 자동 취소 — 사업장 폼(머리의 「저장」)과 저장이 갈린다(자기 경로·자기 버튼). 등록 중
                    (`custCd` 0 — ROOT·사업장 추가·검색 직후)에는 대상이 없어 그리지 않고, 다른 사업장을 고르면 다시 읽는다.
                  -->
                  <CustOrderAcceptPolicyPanel v-if="inputFormCust.custCd" :cust-cd="inputFormCust.custCd" />
                </div>
              </el-card>
            </div>
            <div v-show="!inputFormIsCust">
              <!-- 매장 입력 팝업 -->
              <StoreFormContainer
                ref="storeFormRef"
                @save-lock="setSaveLocked"
                :btn="btn"
                :selected-store-cd="selectedStore?.cd"
                :search="search"
                :custSearch="custSearch"
                :cust="cust" />
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>

      <!--
        「비활성 매장 관리」는 **오더엔 내부 관리자**의 탭이다. 두 표면
        (`POST /store/inactive/search`·`POST /store/hideInOrdertalk/bulk`)의 서버 가드가 회차 3 에서
        `CallerScopeResolver.isInternal`(= admin·mng)로 바뀌었고 리소스 행도 두 역할에 있다.
      -->
      <el-tab-pane :label="$t('비활성 매장 관리')" name="inactive" v-if="isInternalAdmin" lazy>
        <InactiveStorePanel />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { initData } from '@/utils/constants'
import { pickAddress } from '@/utils/addressPicker'
import { CUST_OPTIONS_API, custOptionsQuery } from '@/utils/custOptions'
import { announceInitialAccount } from '@/utils/initialAccount'
import { adminRoleMixin } from '@/mixins/adminRoleMixin'
import mainVueMixin from '@/mixins/mainVueMixin'
import { util } from '@/mixins/utilMixin'
import { pageRows } from '@/utils/pagedList'
import { ORDER_LIST_ACTION, ORDER_REFUND_PENDING_PATH, ORDER_REFUND_TEXT } from '@/utils/orderRefund'

import StoreFormContainer from '@/components/customer/tree/StoreFormContainer.vue'
import CustOrderAcceptPolicyPanel from '@/components/customer/CustOrderAcceptPolicyPanel.vue'
import InactiveStorePanel from '@/components/store/InactiveStorePanel.vue'
import CeoVerificationLine from '@/components/common/CeoVerificationLine.vue'
import { mapGetters } from 'vuex'

export default {
  mixins: [mainVueMixin, adminRoleMixin],

  components: {
    StoreFormContainer,
    CustOrderAcceptPolicyPanel,
    InactiveStorePanel,
    CeoVerificationLine,
  },

  data: function () {
    var data = initData()
    data.url = '/cust'
    data.cust = []

    data.bankTp = []

    data.activeTab = 'tree'
    data.refundText = ORDER_REFUND_TEXT
    data.inputFormIsCust = true

    data.searchForm = this.initSearchForm()
    data.inputFormCust = this.initInputFormCust()
    data.formErrorCust = this.initFormErrorCust()

    data.selectedStore = null

    data.treeData = [
      {
        cd: 0,
        label: 'ROOT',
        children: [],
      },
    ]

    data.defaultProps = { children: 'children', label: 'label' }

    data.lans = []
    data.imgList = []
    data.showImgSelect = true
    data.storeTp = []
    data.payTp = []
    data.filterTp = []
    data.webSalesTp = []
    data.appSalesTp = []
    data.menuShowTp = []
    data.globalVatTp = []
    data.globalServiceCostTp = []

    data.simpleWeeks = [{ label: this.$t('평일') }, { label: this.$t('주말') }]

    data.detailWeeks = [
      { label: this.$t('월요일'), value: 1 },
      { label: this.$t('화요일'), value: 2 },
      { label: this.$t('수요일'), value: 3 },
      { label: this.$t('목요일'), value: 4 },
      { label: this.$t('금요일'), value: 5 },
      { label: this.$t('토요일'), value: 6 },
      { label: this.$t('일요일'), value: 7 },
    ]

    return data
  },
  computed: {
    ...mapGetters({
      inputHeight: 'ui/inputHeight',
    }),
    /**
     * 환불 실패 목록 버튼 — 오더엔 내부 계정(서버가 매장을 가로지르는 계정)이고 그 화면의 가드 액션을 가진 세션에만. 액션은 라우터
     * 가드의 `meta.requiredAction` 과 같은 값이다(보이는 버튼이 열리지 않는 일이 없다).
     */
    canOpenRefundPending() {
      return this.isInternalAdmin && this.checkAuthActionAccess(ORDER_LIST_ACTION)
    },
  },
  created: function () {
    this.custSearch('')

    this.initBankTp()
    this.initGlobalVatTp()
    this.initGlobalServiceCostTp()
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  methods: {
    openRefundPending: function () {
      this.$router.push(ORDER_REFUND_PENDING_PATH).catch(() => {})
    },
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        topCustCd: null,
        custNm: '',
        useYn: '',
      }
    },
    // 입력폼 초기화
    initInputFormCust: function () {
      return {
        statu: 'I',
        title: '추가',
        custCd: 0,
        custNm: '',
        busiNum: '',
        ceoNm: '',
        useYn: 'Y',
        tel: '',
        fax: '',
        email: '',
        zipCd: '',
        addr: '',
        addrDtl: '',
        custDesc: '',
        topCust: { custCd: null, custNm: '' },
        files: [],
        delFiles: [],
        startDt: util.getNow('yyyy-MM-dd'),
        endDt: null,
        accountNumber: '',
        bankTp: null,
        accountName: '',
      }
    },
    // 오류 메세지 초기화
    initFormErrorCust: function () {
      return {
        custNm: '',
        busiNum: '',
        ceoNm: '',
        tel: '',
        fax: '',
        email: '',
        zipCd: '',
        addr: '',
        addrDtl: '',
        custDesc: '',
        'topCust.custCd': '',
        startDt: '',
        endDt: '',
        accountNumber: '',
        'bankTp.cd': '',
        accountName: '',
      }
    },
    // 정산은행구분 조회
    initBankTp: function () {
      this.mainVue.$axios.search(
        '/code/getCode/BANK_TP',
        null,
        function (result) {
          this.bankTp = result
        }.bind(this)
      )
    },
    // 부가세
    initGlobalVatTp: function () {
      this.mainVue.$axios.search(
        '/code/getCode/GLOBAL_VAT_TP',
        null,
        function (result) {
          this.globalVatTp = result
        }.bind(this),
        false
      )
    },
    // 봉사료
    initGlobalServiceCostTp: function () {
      this.mainVue.$axios.search(
        '/code/getCode/GLOBAL_SERVICE_COST_TP',
        null,
        function (result) {
          this.globalServiceCostTp = result
        }.bind(this),
        false
      )
    },
    // 추가
    addCust: function () {
      this.inputFormIsCust = true

      this.inputFormCust = this.initInputFormCust()

      // 선택된 사업장 있으면
      if (!util.isEmpty(this.selectData)) {
        this.inputFormCust.topCust = this.selectData
      }

      this.inputFormCust.title = this.$t('사업장 추가')

      this.formErrorCust = this.initFormErrorCust()

      this.setSaveLocked(false)
      this.fromDisabled = false
    },
    // 트리 클릭
    handleNodeClick: function (data) {
      // ROOT 노드 선택 시 진행 안함
      if (data.cd == 0) {
        this.addCust()
        this.inputFormCust.title = this.$t('추가')
        this.btn.addDisabled = true
        this.setSaveLocked(true)
        this.fromDisabled = true
        return
      }

      if (data.label.charAt(0) == 'C') {
        // 사업장
        this.btn.addDisabled = false

        this.mainVue.$axios.get(
          this.url + '/' + data.cd,
          function (result) {
            result.statu = 'U'
            result.title = data.label

            if (util.isEmpty(result.topCust)) {
              result.topCust = { custCd: null, custNm: '' }
            }

            result.delFiles = []

            this.inputFormCust = result

            this.formErrorCust = this.initFormErrorCust()

            this.setSaveLocked(false)
            this.fromDisabled = false

            // 매장 등록을 위해 사업장 정보 저장
            this.selectData = result

            this.inputFormIsCust = true
          }.bind(this),
          true
        )
      } else {
        // 매장 — **조회는 매 클릭마다 명시적으로** 부른다. 종전에는 `selectedStoreCd` watcher 에
        // 맡겼는데, 같은 매장을 다시 누르면 값이 그대로라 watcher 가 돌지 않아 잠금이 풀리지 않았다
        // (저장 성공 → 트리 재조회 → 같은 매장 재클릭이 평범한 흐름이다). 잠금·해제는 그 조회가 소유한다
        this.btn.addDisabled = true
        this.inputFormIsCust = false
        this.selectData = null
        this.fromDisabled = false

        this.selectedStore = data
        this.$refs.storeFormRef.loadStore(data.cd)
      }
    },
    // Tree 데이터 생성
    convertData: function (result) {
      var treeData = []

      for (var i = 0, len = result.length; i < len; i++) {
        var tmp = this.convertData(result[i].subCust)

        for (var j = 0, jlen = result[i].stores.length; j < jlen; j++) {
          tmp.push({
            cd: result[i].stores[j].storeCd,
            label:
              result[i].stores[j].storeId +
              ' ' +
              result[i].stores[j].storeNmLan +
              ('N' == result[i].stores[j].useYn ? ' (삭제)' : ''),
            children: null,
          })
        }

        treeData.push({
          cd: result[i].custCd,
          label: result[i].custId + ' ' + result[i].custNm + ('N' == result[i].useYn ? ' (삭제)' : ''),
          children: tmp.length > 0 ? tmp : null,
        })
      }

      return treeData
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url + '/tree',
        this.searchForm,
        function (result) {
          if (null != result) {
            this.treeData[0].children = this.convertData(result)
          }

          this.selectData = null
          this.addCust()
          this.inputFormCust.title = this.$t('추가')
          this.btn.addDisabled = true
          this.setSaveLocked(true)
          this.fromDisabled = true
        }.bind(this),
        false
      )
    },
    // 트리 체크 이벤트
    treeCheckChange: function () {
      if (this.$refs.tree.getCheckedNodes().length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }
    },
    // 삭제
    del: function () {
      if (this.$refs.tree.getCheckedNodes().length > 0) {
        var delCust = ''
        var delStore = ''

        for (var i = 0, len = this.$refs.tree.getCheckedNodes().length; i < len; i++) {
          var node = this.$refs.tree.getCheckedNodes()[i]

          if (node.label.charAt(0) == 'C') {
            // 사업장
            if ('' == delCust) {
              delCust += node.cd
            } else {
              delCust += ',' + node.cd
            }
          } else {
            if ('' == delStore) {
              delStore += node.cd
            } else {
              delStore += ',' + node.cd
            }
          }
        }

        if ('' != delCust || '' != delStore) {
          // 사업장 삭제
          this.mainVue
            .$confirm(this.$t('사업장(매장) 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
              confirmButtonText: this.$t('삭제'),
              cancelButtonText: this.$t('취소'),
              type: 'info',
            })
            .then(
              function () {
                var q = 0
                if ('' != delCust) {
                  q++
                }

                if ('' != delStore) {
                  q++
                }

                if ('' != delCust) {
                  this.mainVue.$axios.del(
                    this.url + '/' + delCust,
                    function (result) {
                      q--
                      if (q < 1) {
                        this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                        this.search()
                      }
                    }.bind(this),
                    true
                  )
                }

                if ('' != delStore) {
                  this.mainVue.$axios.del(
                    '/store/' + delStore,
                    function (result) {
                      q--
                      if (q < 1) {
                        this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                        this.search()
                      }
                    }.bind(this)
                  )
                }
              }.bind(this)
            )
            .catch(
              function () {
                this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
              }.bind(this)
            )
        }
      }
    },
    save: function () {
      if (this.inputFormIsCust) {
        this.saveCust()
      }
    },
    // 저장
    saveCust: function () {
      this.formErrorCust = this.initFormErrorCust()

      this.inputFormCust.files = this.inputFormCust.files.concat(this.inputFormCust.delFiles)

      if ('I' === this.inputFormCust.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputFormCust,
          this.formErrorCust,
          function (result) {
            // 새 사업장 계정의 처음 비밀번호 — 이 응답에 한 번뿐이다(결정 47 ③)
            announceInitialAccount(this.$alert.bind(this), result)
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.search()
          }.bind(this),
          true
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputFormCust.custCd,
          this.inputFormCust,
          this.formErrorCust,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.search()
          }.bind(this),
          true
        )
      }
    },
    // 첨부 파일 추가
    custFileAdd: function (file, fileList) {
      util.imgToBase64(
        URL.createObjectURL(file.raw),
        file.raw.type,
        function (data) {
          this.inputFormCust.files.push({
            url: data,
            name: file.name,
            status: 'ready',
          })
        }.bind(this)
      )
    },
    // 수정 시 업로드 했던 이미지 삭제 시 삭제 리스트에 저장
    custFileRemove: function (file, fileList) {
      var tmp = -1
      for (var i = 0, len = this.inputFormCust.files.length; i < len; i++) {
        if (this.inputFormCust.files[i].url == file.url) {
          tmp = i
        }
      }

      if (tmp > -1) {
        this.inputFormCust.files.splice(tmp, 1)
      }

      if (file.status == 'success') {
        file.status = 'del'
        this.inputFormCust.delFiles.push(file)
      }
    },
    fileNameChange: function (file) {
      if ('ready' != file.status) {
        file.status = 'change'
      }
    },
    /**
     * 주소 선택 — 위젯은 `utils/addressPicker` 한 곳이 만진다(종전 `initDaumCust` 다섯 사본을 접었다).
     * 채우는 필드(우편번호·주소)와 포커스 이동은 종전 그대로다.
     */
    selectCustAddress: async function () {
      let picked = null
      try {
        picked = await pickAddress({ geocode: false })
      } catch (error) {
        this.$message({ type: 'error', message: error.message })

        return
      }
      if (!picked) return

      this.inputFormCust.zipCd = picked.zonecode
      this.inputFormCust.addr = picked.address

      this.$refs.addr_dtl.focus()
    },

    /**
     * **저장 잠금 한 자리** — 이 화면은 사업장 폼과 매장 폼이 `btn` 하나를 함께 쓴다.
     *
     * 다섯 자리(사업장 추가·ROOT 선택·사업장 조회 성공·검색 후 초기화·매장 등록)가 각자 대입하고
     * 자식의 `save-lock` 까지 여섯 번째로 들어오던 축이라, 규칙을 고칠 때 한 곳을 빠뜨리기 쉽다.
     * 다른 버튼 플래그(`addDisabled`·`delDisabled`)는 각자 자리에 그대로 둔다 — 이 축만 모은다.
     */
    setSaveLocked: function (locked) {
      this.btn.saveDisabled = locked
    },

    // 매장 추가
    addStore: function () {
      this.inputFormIsCust = false

      this.$refs.storeFormRef.onAddNewStore(this.selectData)

      // 등록 폼은 조회가 없다 — 잠금을 푸는 자리가 여기다(매장 노드 클릭은 `loadStore` 가 소유한다)
      this.setSaveLocked(false)
      this.fromDisabled = false
    },

    // 고객사 자동 검색 — 셀렉트 전용이라 **전량**이다. URL·조건은 [custOptionsQuery] 한 곳이 소유한다
    custSearch: function (custNm) {
      this.mainVue.$axios.search(
        CUST_OPTIONS_API,
        custOptionsQuery({ custNm: custNm }),
        function (result) {
          this.cust = pageRows(result)
          this.cust.unshift({ custCd: null, custNm: '' })
        }.bind(this)
      )
    },
  },
}
</script>

<style scoped>
.el-upload-list__item {
  -webkit-transition: none;
  transition: none;
}

.file_name .el-textarea__inner {
  height: 90px;
}
</style>
